// Utility
import logger from '../../utility/loggerUtil'
import isEmpty from '../../utility/isEmpty'
import session from '../../utility/sessionUtil'

// Constants
import { CookieConstants, TlxeLoanStatusEnum } from '../../constants'

// API
import api from '../../api'

export default {
  async getOriginationInfo (context) {
    try {
      const originationInfo = await api.origination.getOriginationInfo(context.state.applicationId)
      context.commit('setOriginationInfo', originationInfo)
    } catch (e) {
      logger.error('Error getting origination info from API.')
      logger.debug(e)
      throw e
    }
  },

  async loanOriginate (context) {
    try {
      const response = await api.origination.originate(
        context.state.applicationId,
        context.state.appraisalId,
        context.rootState.payment.disburseCardIds,
        context.state.disbursementAmount,
        context.state.disbursementType,
        context.state.loanTypeCode,
        context.state.locationId,
        context.state.locationBrand,
        context.state.productId,
        context.state.storeId
      )
      context.commit('setOriginationKey', response.messageKey)
    } catch (e) {
      logger.error('Error originating loan from API.')
      logger.debug(e)
      throw e
    }
  },

  async getLoanOriginateStatus (context, messageKey) {
    try {
      const response = await api.origination.getOriginationStatus(messageKey)

      if (!isEmpty(response)) {
        logger.info(`Got new LoanId from Origination: ${response.loanId}`)
        context.commit('setNewLoanInfo', {
          collateral: response.collateral,
          dueDate: response.dueDate,
          loanAmount: response.loanAmount,
          loanId: response.loanId
        })
      }

      return response
    } catch (e) {
      logger.error('Error getting loan origination status from API.')
      logger.debug(e)
      throw e
    }
  },

  resumeOrigination (context, customerId) {
    const previousState = JSON.parse(session.getCookie(CookieConstants.origination.key + customerId))
    context.commit('reset', previousState)

    if (context.state.disbursementAmount === 0) {
      return 'OriginationAmount'
    } else if (isEmpty(context.state.disbursementType) || isEmpty(context.state.loanId)) {
      return 'OriginationChooseMethod'
    } else if (context.state.loanStatusId === TlxeLoanStatusEnum.Open) {
      return 'OriginationDocuSign'
    }
  },

  async addToPhoneQueue (context) {
    try {
      await api.origination.addToPhoneQueue(context.state.appraisalId)
    } catch (e) {
      logger.error('Error putting customer in phone queue.')
      logger.debug(e)
      throw e
    }
  }
}
